import React, {useState} from "react";
import {Link} from "react-router-dom";
import {selfcareLoginAdd} from "../../util/request";
import SelfcarePageContent from "../../components/selfcare/SelfcarePageContent";
import useLoginCheck from "../../util/useLoginCheck";
import Routing from "../../Routing.ts";

export default function AddLoginPage() {
    const [email, setEmail] = useState<string>("")

    const [loading, setLoading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)
    const [finished, setFinished] = useState<boolean>(false)

    useLoginCheck()

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true)

        selfcareLoginAdd(email)
            .then(r => {
                if (r.code !== 201) {
                    setErrorMessage(r.response.error_message as string)
                    return
                }

                setSuccessMessage(r.response.success_message as string)
                setFinished(true)
            })
            .catch(() => setErrorMessage("Noget gik galt. Prøv igen"))
            .finally(() => setLoading(false))
    }

    return <SelfcarePageContent title={"Få adgang til Mit Hiper"} className={`selfcare-page-login`}>

        {(errorMessage || successMessage) && <section className="selfcare-messages">
            {errorMessage !== null &&
                <div className="selfcare-message-error show">
                    <p>{errorMessage}</p>
                </div>
            }
            {successMessage !== null &&
                <div className="selfcare-message-success show">
                    <p>{successMessage}</p>
                </div>
            }
        </section>}

        <div className="selfcare-page-summary">
            <p>Vi sender et link til nedenstående email, så du kan oprette en ny kode eller bruger til Mit Hiper.</p>
        </div>
        <form
            onSubmit={handleSubmit}
            className="selfcare-login-resend selfcare-menu__slide"
            id="selfcare-login-resend"
            noValidate
            rel="nofollow"
        >
            <p>
                <input
                    type="text"
                    name="email"
                    disabled={loading || finished}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    id="selfcare-login-resend__email"
                    className=""
                    placeholder="Email"
                    autoComplete={"username"}
                    required
                />
                <span className="input-help-text">
                    Brug den email du har registreret på dit Hiper abonnement.
                    Det er den samme som vi sender dine kvitteringer til.
                </span>
            </p>
            <p className="submit-button-block">
                <label id="submit-form-button">
                    <input disabled={loading || finished} className="continue-button-submit" type="submit"/>
                    <span className="button teal">
                        <span className="text">Send link</span>
                    </span>
                </label>
            </p>
            <Link to={Routing.Selfcare.Login} className={"selfcare-button-bottom"}>
                Jeg har allerede en bruger
            </Link>
        </form>
    </SelfcarePageContent>
}
